import { Text } from '@noorden-insurtech/alba-design-system';
import type {
  DiretrixDocumentLookupState,
  SubStipulantEntry,
} from '../../types';
import type { SubStipulantFieldErrors } from '../utils/validate-risk.util';
import { SubStipulantRow } from './sub-stipulant-row.component';

type Props = {
  items: SubStipulantEntry[];
  onAdd: () => void;
  onRemove: (id: string) => void;
  onPatch: (id: string, partial: Partial<SubStipulantEntry>) => void;
  disabled?: boolean;
  segmentOptions?: Array<{ value: string; label: string }>;
  isSegmentOptionsLoading?: boolean;
  isSegmentOptionsError?: boolean;
  submitAttempted: boolean;
  fieldErrorsById: Record<string, SubStipulantFieldErrors>;
  onDocumentLookupChange: (
    id: string,
    state: DiretrixDocumentLookupState
  ) => void;
};

export function SubStipulantsList({
  items,
  onAdd,
  onRemove,
  onPatch,
  disabled,
  segmentOptions,
  isSegmentOptionsLoading,
  isSegmentOptionsError,
  submitAttempted,
  fieldErrorsById,
  onDocumentLookupChange,
}: Props) {
  if (items.length === 0) return null;

  return (
    <div className='flex flex-col gap-10'>
      <Text className='text-lg font-bold text-alba-black-500'>
        Subestipulantes
      </Text>

      {items.map((sub, index) => (
        <SubStipulantRow
          key={sub.id}
          item={sub}
          onPatch={partial => onPatch(sub.id, partial)}
          disabled={disabled}
          segmentOptions={segmentOptions}
          isSegmentOptionsLoading={isSegmentOptionsLoading}
          isSegmentOptionsError={isSegmentOptionsError}
          submitAttempted={submitAttempted}
          fieldErrors={fieldErrorsById[sub.id]}
          isLast={index === items.length - 1}
          onAddAnother={onAdd}
          onRemove={() => onRemove(sub.id)}
          onDocumentLookupChange={state =>
            onDocumentLookupChange(sub.id, state)
          }
        />
      ))}
    </div>
  );
}
